import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {RouterLink, RouterOutlet} from "@angular/router";
import {AuthService} from "../../service/auth.service";
import {userReadWriteGroups} from "../../../assets/user-groups";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {NgOptimizedImage} from "@angular/common";
import {NgbCollapse} from "@ng-bootstrap/ng-bootstrap";
import {MatTooltip} from "@angular/material/tooltip";
import {Subject} from "rxjs";

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrl: "./navbar.component.scss",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatIconButton,
        MatIcon,
        RouterLink,
        MatTooltip,
        NgbCollapse,
        NgOptimizedImage,
        RouterOutlet
    ]
})
export class NavbarComponent implements OnInit, OnDestroy {
    userNameAndEmail: string = ""
    isNavMenuCollapsed: boolean = true;
    private ngUnsubscribe$ = new Subject();

    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.authService.hasReadWriteGroups(userReadWriteGroups.DLI);
        this.userNameAndEmail = this.authService.getUserNameAndEmail();
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.complete();
    }

    logout() {
        this.authService.logout();
    }

}
